import { defineComponent as _defineComponent } from 'vue'
import { AbLink } from '../../ui';
import { CategoryCard } from '../';
// TODO: fix type
interface Props {
  category: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCards',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
  category: any;
};



const classOfCard = (index: number) => {
  let res = '';
  const categoryChildrenLength = props.category.children.length;

  if (index === 0) {
    res = 'cn-category-cards__item--first';
  } else if (index === categoryChildrenLength - 1) {
    res =
      categoryChildrenLength === 3
        ? 'cn-category-cards__item--third'
        : 'cn-category-cards__item--last';
  }

  return res;
};

const isSmall = (index: number) => {
  const categoryChildrenLength = props.category.children.length;

  if (index === 0) {
    return false;
  }

  if (index === categoryChildrenLength - 1) {
    return categoryChildrenLength === 3;
  }

  return true;
};

return { __sfc: true,props, classOfCard, isSmall, AbLink, CategoryCard }
}

})